import React from 'react'
import { formatCurrency } from '../util'

export const CreditCardAccountCardSummary = (props) => {
  const {
    product: {
      last_four,
    } = {}
  } = props

  return(
    <div styleName="loan-card__summary">
      <h3 styleName="loan-card__summary-label label label--large">
        <svg role="img" styleName="loan-card__summary-icon loan-card__summary-icon--sm"><use xlinkHref="#icon-product" /></svg>
        <svg role="img" styleName="loan-card__summary-icon loan-card__summary-icon--lg"><use xlinkHref="#icon-certificate" /></svg>
        Card Number
      </h3>
      <div styleName="loan-card__summary-amount datapoint datapoint--small-bold">
          *{last_four}
      </div>
    </div>
  )
}

export const CreditCardAccountCardDetails = (props) => {
  const {
    components: {
      ViewProduct = () => null,
      CreditCardAccountBalance = () => null
    } ={}
  } = props
  return(
    <div styleName="loan-card__details">
      <CreditCardAccountBalance />
      <ViewProduct />
    </div>
  )
}

export const CreditCardAccountBalanceSummary = (props) =>{
  const {
    t,
    product: {
      current_balance_cents,
      available_total_credit_cents,
      credit_limit_cents,
    } = {},
    components: {
      PaymentInfo = () => null
    } = {}
  } = props
  return(
      <div styleName="loan-card__payment">
        <div styleName="loan-card__payment-date">
          <h4 styleName="loan-card__payment-label label label--large">
            {t('product.credit_card_account.current_balance')}
          </h4>
          <div styleName="loan-card__payment-date-due datapoint datapoint--small-bold">
            {formatCurrency(current_balance_cents)}
          </div>
          <br />
          <div styleName="loan-card__payment-date-via">
            <PaymentInfo />
          </div>
        </div>
        <div styleName="loan-card__payment-amount">
          <h4 styleName="loan-card__payment-label label label--large">
            {t('product.credit_card_account.available_credit')}
          </h4>
          <div styleName="loan-card__payment-amount-due datapoint datapoint--small-bold">
            {formatCurrency(available_total_credit_cents)}
          </div>
          <div style={ {textAlign: 'right'} }>Credit Limit {formatCurrency(credit_limit_cents)}</div>
        </div>
      </div>
  )
}

export const ViewCreditCardAccountCta = (props) => {
  const { product: { uuid }} = props
  return(
    <div styleName="loan-card__cta">
      <a href={`/card/${uuid}`} styleName="button button--secondary">
        <span>View Card</span>
        <svg role="img" styleName="icon-arrow"><use xlinkHref="#icon-arrow-right" /></svg>
      </a>
    </div>
  )
}


